import { useMemo } from "react";

import { DataGrid, GridToolbar } from "@mui/x-data-grid";

export const RTFOPressureAnalysisTable = ({ currentRTFO, monitorWellEvents, fiberData, currentStageName, monitorUWI }) => {
  
  const columns = [
    {
      field: 'wellName',
      headerName: 'Well Name',
      width: 100,
      editable: false,
      sortable: true,
      filterable: true,
      type: 'string'
    },
    {
      field: 'stageNumber',
      headerName: 'Stage Number',
      width: 100,
      editable: false,
      sortable: true,
      filterable: true,
      type: 'string'
    },
    {
      field: 'monitorUWI',
      headerName: 'Observation Well',
      width: 150,
      editable: false,
      sortable: true,
      filterable: true,
      type: 'string'
    },
    {
      field: 'name',
      headerName: 'Event',
      width: 150,
      editable: false,
      sortable: true,
      filterable: true,
      type: 'string'
    },
    {
      field: 'date',
      headerName: 'Date',
      width: 150,
      editable: false,
      sortable: true,
      filterable: true,
      type: 'string'
    },
    {
      field: 'deltaTime',
      headerName: 'Time From Start (min)',
      width: 150,
      editable: false,
      sortable: true,
      filterable: true
    },
    {
      field: 'pressure',
      headerName: 'Treating Pressure (MPa)',
      width: 150,
      editable: false,
      sortable: true,
      filterable: true
    },
    {
      field: 'rate',
      headerName: 'Slurry Rate (m3/min)',
      width: 150,
      editable: false,
      sortable: true,
      filterable: true
    },
    {
      field: 'proppant',
      headerName: 'Proppant Conc. (kg/m3)',
      width: 150,
      editable: false,
      sortable: true,
      filterable: true
    },
    {
      field: 'slurryVolume',
      headerName: 'Slurry Volume (m3)',
      width: 150,
      editable: false,
      sortable: true,
      filterable: true
    },
    {
      field: 'vfr',
      headerName: 'VFR (m3)',
      width: 150,
      editable: false,
      sortable: true,
      filterable: true
    },
    {
      field: 'cumProppant',
      headerName: 'Cum. Proppant (ton)',
      width: 150,
      editable: false,
      sortable: true,
      filterable: true
    },
    {
      field: 'distance',
      headerName: 'Distance (m)',
      width: 150,
      editable: false,
      sortable: true,
      filterable: true
    },
    {
      field: 'diffusivity',
      headerName: 'Diffusivity (m2/m3)',
      width: 150,
      editable: false,
      sortable: true,
      filterable: true
    },
    // {
    //   field: 'xfLow',
    //   headerName: 'Xf Low (m)',
    //   width: 150,
    //   editable: false,
    //   sortable: true,
    //   filterable: true
    // },
    // {
    //   field: 'xfHigh',
    //   headerName: 'Xf High (m)',
    //   width: 150,
    //   editable: false,
    //   sortable: true,
    //   filterable: true
    // },
    {
      field: 'xfAvg',
      headerName: 'Xf Avg. (m)',
      width: 150,
      editable: false,
      sortable: true,
      filterable: true
    }
  ];


  const rows = useMemo(() => {
    const data = [];
    if (monitorWellEvents?.length > 0) {
      // let diffusivities = [];
      // monitorWellEvents?.forEach(e => (e.diffusivity > 0 && e.name !== 'Stage Start' && diffusivities.push(e.diffusivity)));
      // diffusivities = diffusivities?.sort((a, b) => a - b);

      // const midPoint = Math.floor(diffusivities?.length / 2);

      // const avgDiffusivitiesLow = diffusivities.slice(0, midPoint);
      // const avgLow = avgDiffusivitiesLow?.reduce((tot, curr) => tot + curr, 0) / avgDiffusivitiesLow?.length;
      // const avgHigh = Math.max(...diffusivities);
      
      monitorWellEvents?.filter(e => e.name !== 'Stage Start')?.forEach((event,i) => {
        
        const totalSlurryVolume = currentRTFO?.stageData?.[event?.stageName]?.metrics?.totalSlurryVolume || 0;
        data.push({
          id: event?.stageName + '-' + i,
          name: event?.name,
          wellName: event?.stageName?.split('_')?.[1],
          stageName: event?.stageName,
          stageNumber: event?.stageName?.split('_')?.[2],
          monitorUWI: event?.monitorUWI || '',
          date: event?.date,
          deltaTime: Number((event?.deltaTime || 0)?.toFixed(2)),
          pressure: Number((event?.pressure || 0)?.toFixed(2)),
          rate: Number((event?.rate || 0)?.toFixed(2)),
          proppant: Number((event?.proppant || 0)?.toFixed(2)),
          slurryVolume: Number((event?.slurryVolume || 0)?.toFixed(2)),
          vfr: Number((event?.slurryVolume || 0)?.toFixed(2)),
          cumProppant: Number((event?.cumProppant || 0)?.toFixed(2)),
          distance: Number((event?.distance || 0)?.toFixed(2)),
          diffusivity: Number((event?.diffusivity || 0)?.toFixed(2)),
          // xfLow: Math.sqrt(4 * Math.PI * totalSlurryVolume * avgLow)?.toFixed(2) || 0,
          // xfHigh: Math.sqrt(4 * Math.PI * totalSlurryVolume * avgHigh)?.toFixed(2) || 0,
          // xfAvg: +((Math.sqrt(4 * Math.PI * totalSlurryVolume * avgLow) + Math.sqrt(4 * Math.PI * totalSlurryVolume * avgHigh)) / 2)?.toFixed(2) || 0
          xfAvg: +(Math.sqrt(4 * Math.PI * totalSlurryVolume * event?.diffusivity)?.toFixed(2)) || 0
        });
      });
    }

    if (fiberData?.length > 0) {
      fiberData?.forEach((event,i) => {
        const totalSlurryVolume = currentRTFO?.stageData?.[event?.stageName]?.metrics?.totalSlurryVolume || 0;

        data.push({
          id: event?.eventId,
          name: event?.name,
          wellName: event?.wellName,
          stageName: event?.stageName,
          stageNumber: event?.stageNumber,
          monitorUWI: event?.monitorUWI || event?.monitorName || '',
          date: event?.date,
          deltaTime: Number((event?.deltaTime || 0)?.toFixed(2)),
          pressure: Number((event?.pressure || 0)?.toFixed(2)),
          rate: Number((event?.rate || 0)?.toFixed(2)),
          proppant: Number((event?.proppant || 0)?.toFixed(2)),
          slurryVolume: Number((event?.slurryVolume || 0)?.toFixed(2)),
          vfr: Number((event?.vfr || 0)?.toFixed(2)),
          cumProppant: Number((event?.cumProppant || 0)?.toFixed(2)),
          distance: Number((event?.distance || 0)?.toFixed(2)),
          diffusivity: Number((event?.diffusivity || 0)?.toFixed(2)),
          // xfLow: +(event?.xfLow)?.toFixed(2) || 0,
          // xfHigh: +(event?.xfHigh)?.toFixed(2) || 0,
          // xfAvg: +((event?.xfLow + event?.xfHigh) / 2)?.toFixed(2) || 0
          xfAvg: +(Math.sqrt(4 * Math.PI * totalSlurryVolume * event?.diffusivity)?.toFixed(2)) || 0

        });
      });
    }

    return data;
  }, [currentRTFO?.stageData, fiberData, monitorWellEvents]);
  
  
  return (
    <DataGrid
      density="compact"
      rows={rows}
      columns={columns}
      rowsPerPageOptions={[10,25,50,100]}
      disableSelectionOnClick
      sx={{
        '& .super-app-theme--Current': {
          fontWeight: 'bold',
          backgroundColor: 'rgba(7, 88, 183, 0.1)' // highlight the current row
        }
      }}
      components={{
        Toolbar: GridToolbar,
      }}
      style={{fontSize: '12px', border: 'none'}}
      getRowClassName={(params) => {
        return (params?.row?.stageName === currentStageName && params?.row?.monitorUWI === monitorUWI) ? `super-app-theme--Current` : '';
      }}
    />
  );
};